import { Box, AppBar, Toolbar } from '@mui/material';
import { AuthButton, HeaderWelcomeUserComponent } from '@myorg/shared';
import { theme } from '@myorg/shared';
import logoSrc from '../assets/images/logo.png';
import { useStyles } from './styles';
import { ImgStyled } from './layout.styled';
import ContextHeader from './context-header';
import Footer from './footer';

export default function Header() {
  return (
    <Box
      sx={{
        flexGrow: 1,
        top: 0,
        width: '100%',
        zIndex: 3,
        position: 'fixed',
      }}
    >
      <AppBar
        sx={{
          position: 'static'
        }}
      >
        <Toolbar
          sx={{
            backgroundColor: '#fff',
            display: 'flex',
            justifyContent: 'space-between',
            height: '70px'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <a href="/" style={{ display: 'flex', alignItems: 'center'}}>
              <ImgStyled src={logoSrc} alt="logo" />
            </a>
            <ContextHeader />
          </Box>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '3rem'
            }}
          >
            <HeaderWelcomeUserComponent></HeaderWelcomeUserComponent>
            <AuthButton></AuthButton>
          </div>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export function Dashboard({noMargin = false, children }) {
  const classes = useStyles({noMargin});

  return (
    <Box>
      <Header />
      <main role="main" className={classes.main} style={{ minHeight: '100vh'}} >
        {children}
      </main>
      <Footer />
    </Box>
  );
}
